var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscoBall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.999,
    height: 42,
    viewBox: "0 0 34.999 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "disco-ball",
    d: "M21.249,7.089V3.5h3.5a1.75,1.75,0,1,0,0-3.5H14.25a1.75,1.75,0,1,0,0,3.5h3.5V7.089a17.5,17.5,0,1,0,3.5,0ZM26.5,27.422V21.577c4.609.819,7,2.289,7,2.922S31.109,26.6,26.5,27.422ZM5.5,24.5c0-.633,2.39-2.1,7-2.922v5.845C7.89,26.6,5.5,25.133,5.5,24.5ZM16,21.136C17.086,21.05,18.248,21,19.5,21s2.413.051,3.5.136v6.727c-1.087.086-2.249.136-3.5.136s-2.413-.051-3.5-.136ZM19.5,10.5a13.917,13.917,0,0,1,3.5.46v6.671c-1.162-.086-2.336-.131-3.5-.131s-2.338.045-3.5.131V10.96A13.917,13.917,0,0,1,19.5,10.5Zm13.125,9.163A26.154,26.154,0,0,0,26.5,18.024V12.393a14.073,14.073,0,0,1,6.125,7.269ZM12.5,12.393v5.631a26.155,26.155,0,0,0-6.125,1.633A14.073,14.073,0,0,1,12.5,12.393ZM6.375,29.336A26.155,26.155,0,0,0,12.5,30.974V36.61a14.073,14.073,0,0,1-6.125-7.274ZM16,38.038V31.368c1.162.086,2.336.131,3.5.131s2.338-.045,3.5-.131v6.671A13.537,13.537,0,0,1,16,38.038Zm10.5-1.433V30.974a26.155,26.155,0,0,0,6.125-1.633A14.073,14.073,0,0,1,26.5,36.605Z",
    transform: "translate(-2)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoBall);
export default __webpack_public_path__ + "static/media/disco-ball.084e40a05fa0814bc7c284c3c9e3c3e6.svg";
export { ForwardRef as ReactComponent };